// src/screens/Parents/config/ParentThemeContext.js
import React, { createContext, useMemo, useState } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';

export const ParentThemeContext = createContext({ toggleMode: () => {} });

const getTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            background: {
              default: '#F3F7FD',
              paper: '#fff',
              lightGray: '#F4F4F4',
              lightBlue: '#EDF7FD',
              bookingFooter: '#F5F6F8'
            },

            bookingContent:{
                tab:{
                    background:'#E7E9EF',
                    activeBg:'#fff',
                    border:'#D8DFEE',
                    indicator:'#0F467A',
                    hover:'#D8DFEE',
                    text:'#0F467A',
                },
                accordionBg:'#EEF0F5',
                accordContent:'#fff',
                dialogBg:'#F3F7FD',
                appbar:'#3D5AF1',
                buttonColor:'#fff',
                totalSectionHead:'#0F467A',
                 quiz:{
                    answerBg:'#FAFAFA',
                    border:'#EAEAEA',
                    hover:'#DFDFDF',
                    selectAnswer:'#DDF3FF',
                    selectHover:'#DDF3FF'
                }
            },

            bottomMenuActiveText:'#000',

            drawer:{
                whiteBg:'#fff'
            },

            button:{
                gray:'#E9EDF3'
            },

            menu:{
                text:'#000',
                hover:'#f1f7ff',
                hoverText:'#000',
                active:'#003E93',
                activeText:'#fff',
                border:'#F3F7FD'
            },

            support:{
                card:{
                    background:'#F8F8F8',
                    border:'#D2D7E1',
                },
                open:'#FFE7A1',
                closed:'#DEF7CD',
                inProgress:'#CCE7F9'
            },

            text:{
                primary:'#000',
                gray:'#707070',
                // secondary:'#8f9bb3',
            },

            checkbox:{
                main:'#00000029',
            }
          }
        : {
            background: {
              default: '#242729',
              paper: '#1A1C1E',
              lightGray: '#ffffff1f',
              lightBlue: '#ffffff1f',
              bookingFooter: '#040D12'
            },

            bookingContent:{
                tab:{
                    background:'#1A1C1E',
                    activeBg:'#1B1A55',
                    border:'#ffffff1f',
                    indicator:'#7077A1',
                    hover:'#2D3250',
                    text:'#ffffffb3',
                },
                accordionBg:'#1A1C1E',
                accordContent:'#242729',
                dialogBg:'#040D12',
                appbar:'#1B1A55',
                buttonColor:'#ffffffb3',
                totalSectionHead:'#1B1A55',
                quiz:{
                    answerBg:'#0B192C',
                    border:'#ffffff1f',
                    hover:'#021526',
                    selectAnswer:'#03346E',
                    selectHover:'#1E3E62'
                }
            },

            bottomMenuActiveText:'#7077A1',

            drawer:{
                whiteBg:'#242729'
            },

            button:{
                gray:'#ffffff0d'
            },

            menu:{
                text:'#8f9bb3',
                hover:'#ffffff0d',
                hoverText:'#fff',
                active:'#1A1C1E',
                activeText:'#fff',
                border:'#8f9bb3'
            },

            support:{
                card:{
                    background:'#1A1C1E',
                    border:'#ffffff1f',
                },
                open:'#BDA45F',
                closed:'#08A803',
                inProgress:'#003E93'
            },

            text:{
                primary:'#ffffffb3',
                gray:'#ffffffb3',
                // secondary:'#8f9bb3',
            },
             checkbox:{
                main:'#ffffffb3',
            }
          }),
    },
  });

export const ParentThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(localStorage.getItem('parent-mode') || 'light');

  const toggleMode = () => {
    console.log('Toggling mode:', mode);
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    localStorage.setItem('parent-mode', newMode);
  };

  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ParentThemeContext.Provider value={{ mode, toggleMode }}>
      <MuiThemeProvider theme={theme}>
        {/* <CssBaseline /> */}
        {children}
      </MuiThemeProvider>
    </ParentThemeContext.Provider>
  );
};
